import OrderDTO from "@/dto/order/OrderDTO";

export enum PrintRuleLevel {
    FORBIDDEN = "forbidden",
    OPTIONAL = "optional",
}

export interface PrintRule {
    id: string;
    label: string;
    level: PrintRuleLevel;
    match(order: OrderDTO): boolean | Promise<boolean>;
    message?: string;
}

export interface RuleHit {
    rule: PrintRule;
    orders: OrderDTO[];
}

export interface PrintCheckResult {
    totalOrders: OrderDTO[];
    forbidden: RuleHit[];
    optional: RuleHit[];
    forbiddenOrderIds: Set<number>;
    /** 订单ID -> 命中的optional规则ID列表的映射 */
    orderToOptionalRules: Map<number, string[]>;
    /** 至少命中一个optional规则的订单数量（去重） */
    optionalOrderCount: number;
}
